import React from 'react';
import {reduxForm } from 'redux-form';
//import { Link } from 'react-router-dom';
import fields from './fields';
import RenderField from '../FieldRenderComponent';
import { connect } from 'react-redux';
//import constants from '../Constants';
import { returnObjectData, returnCarrierName, returnFormattedDate, getCoverageType } from '../utils/formatReturnedData';
import moment from  'moment';

let HistoryForm = (props) => {

    return (
        <div>
            {fields.map((field, index) => {
                
                return (
                    <RenderField key={index} {...field} />
                );
            })}
            {/*
            <Link
                className="btn btn-primary"
                to={onNextPage}>
                {'Next '}
                <i className={constants.icons.next} />
                </Link>
                */}
        </div>
    )
}

HistoryForm = reduxForm({
    form: 'history',
    enableReinitialize: true
})(HistoryForm);


export default connect(
    (state, props) => {
        //console.log(state);

        function getPolicyHolderFullName (policyHolderObj){
            if(policyHolderObj !== undefined){                
                return `${policyHolderObj.givenName} ${policyHolderObj.surname}`;
            }
            else{
                return null
            }
        }

        const currentPolicy = state.quoteStart.underWriting.underwriting.body.completeQuote.History;
        console.log(props);
        const policyType = returnObjectData(currentPolicy, 'policyType');
        const carrier = returnCarrierName(currentPolicy, 'carrier');
        const city = currentPolicy.addresses[0].city;
        const stateCode = currentPolicy.addresses[0].stateCode;
        const street1 = currentPolicy.addresses[0].street1;
        const zip = currentPolicy.addresses[0].zip;
        const {numberOfCoverageDays} = currentPolicy;
        const addressType = currentPolicy.addresses[0].addressType;
        const policyReportedDate = returnFormattedDate(currentPolicy.policyReportedDate);
        const inceptionDate = returnFormattedDate(currentPolicy.inceptionDate);
        const lastReportedTermEffectiveDate = returnFormattedDate(currentPolicy.lastReportedTermEffectiveDate);
        const lastReportedTermExpirationDate = returnFormattedDate(currentPolicy.lastReportedTermExpirationDate);
        const bodilyInjury = getCoverageType(currentPolicy, "BINJ");
        const propertyDamage = getCoverageType(currentPolicy, "PDMG");        
        const policyHolder = getPolicyHolderFullName(currentPolicy.policyHolders[0]);
        

        function lengthWithCurrentInsuranceCompany (days){
            //alert(days);
            days = 1365;
            if(days < 365){
                return `Math.round(days/30.42) months`;
            }
            else if(days > 365){
                return `${Math.floor(days/365)} years`;
            }
            return null
        }



        return ({
            initialValues: {
                ...currentPolicy,
                policyType,
                carrier,
                city,
                stateCode,
                street1,
                zip,
                addressType,
                policyReportedDate,
                inceptionDate,
                lastReportedTermEffectiveDate,
                lastReportedTermExpirationDate:moment().add(5, 'days').format('MM/DD/YYYY'),
                bodilyInjury,
                propertyDamage,
                policyHolder,
                howlongcontinuouslyinsured:lengthWithCurrentInsuranceCompany(numberOfCoverageDays),
                newpolicystartdate: moment().format('MM/DD/YYYY')
            } 
        })
    })(HistoryForm);




// WEBPACK FOOTER //
// ./src/History/HistoryForm.js